import { ScheduleCollectConsignmentData, ScheduleCollectGroup } from 'types';
import { convertTimestampToDate } from 'helpers';

export function scheduledCollectConsigmentFactory(
  params: any = {}
): ScheduleCollectConsignmentData[] {
  return params.map((elem: any) => {
    return {
      consignmentCode: elem.consignmentCode || '',
      user: elem.user || '',
      collectCode: elem.collectCode || '',
    };
  });
}

export function scheduledCollectFactory(
  params: any = {}
): ScheduleCollectGroup[] {
  return params.map((elem: any) => {
    return {
      deliveryModeId: elem.deliveryModeId || '',
      expectedDate: elem.expectedDate
        ? convertTimestampToDate(elem.expectedDate)
        : undefined,
      driverCpf: elem.driverCpf || '',
      driverName: elem.driverName || '',
      consignments: scheduledCollectConsigmentFactory(elem.consignments),
    };
  });
}
